export default __webpack_public_path__ + "graphik-compact-bold.woff";